import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { ReplaySubject, Subscription } from 'rxjs';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AppService } from '@irb/app.service';
import { IrbModelsEvents } from '@irb/irb-models/irb-models.events';
import { SecurityMasterService } from '@irb/irb-models/security-master/security-master.service';
import { DataTransferService } from '@irb-common/services/data-transfer.service';
import { IApplyFilterOnLanding, IFilterModel } from '@irb/app.model';
import { AddMultipleSecuritiesGridService } from '@irb/irb-models/add-multiple-securities-dialog/add-multiple-securities-grid.service';
import {
  ISecurity,
  ISecurityCustomCategories, ISecurityModelList,
  ISecuritySymbolList,
  ISecurityType,
  ISecurityelectAll
} from '@irb/irb-models/irb-models.model';
import {HttpErrorResponse, HttpHeaders} from '@angular/common/http';
import {IrbSettingsService} from '@irb/irb-settings/irb-settings.service';
import { IrbAppEvents, IEventSubscriber, IEvent } from "@irb/irb-common/events";
import { SecurityMasterAssetCategoryService } from '@irb/irb-models/security-master/security-master.asset-category.service';
import {IrbGridBaseClass} from "@irb-common/components/grid/irb-grid.base";

@Component({ standalone: false,
  selector: 'irb-add-multiple-securities-dialog',
  templateUrl: './add-multiple-securities-dialog.component.html',
  styleUrls: ['./add-multiple-securities-dialog.component.scss']
})
export class AddMultipleSecuritiesDialogComponent extends IrbGridBaseClass implements OnDestroy, OnInit, IEventSubscriber  {

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject(1);
  selectedOrDeSelectedRecords: any[] = [];
  deselectedFromSelectAllRecords: any[] = [];
  securityList: ISecuritySymbolList;
  securitySymbolList: any = [];
  customCategoryList: Array<string> = [];
  customCategoriesList: ISecurityCustomCategories;
  securityModelList: any = [];
  footerContent: any;
  securitiesCount: any;
  securityTypeList: any;
  securityModels: any;
  securityModelId: string= '0';
  isSelectedAll: boolean = false;
  params: any;
  gridOptions: any;
  uniqueField = 'securityId';
  totalRecordsFromServer: number= 0;
  applyFilterOnLanding: IApplyFilterOnLanding;
  private securityMaster: any = [];
  dialogTitle: string;
  disableAddBtn: boolean = true;
  filterCriteria: string;
  noDollarCash: boolean = false;
  private originalSecurityFilter = '';
  checkSelected: boolean = true;
  isUiTest = false;
  currentSecurityMasterDisplayed:number;
  eventSubscription: Subscription;
  selectedRowsMap: Map<string, any> = new Map<string, any>();
  isTLHSetInGlobal: boolean = null;
  isTlhWsaEnabled: boolean = false;
  washSaleSymbolList: any[] = [];
  globalSettings: any;
  frameworkComponents: any;
  componentName: string = 'AddMultipleSecuritiesDialogComponent-v002';
  ENABLE_AS_SECTYPE: boolean = false;
  constructor(public dialogRef: MatDialogRef<any>,
              public as: AppService,
              private readonly securityMasterService:SecurityMasterService,
              public dataTransferService: DataTransferService,
              private addMultipleSecuritiesGridService: AddMultipleSecuritiesGridService,
              private iss: IrbSettingsService,
              @Inject(MAT_DIALOG_DATA) public eventData: any,
              public smac: SecurityMasterAssetCategoryService
  ) {
    super();
    this.ENABLE_AS_SECTYPE = this.as.getItem('IRB_APP_CONFIG')?.featureFlags?.ENABLE_AS_SECTYPE;
    this.isTlhWsaEnabled = this.as.getItem('IRB_APP_CONFIG')?.isTlhWsaEnabled;
    this.dialogTitle = 'Add Multiple Securities';
    this.originalSecurityFilter = this.securityMasterService.filterCriteria;
    this.securityMasterService.clearCriteria();
    this.eventSubscription = this.as.getEvents().subscribe((s) => this.processEvent(s));

    if(this.ENABLE_AS_SECTYPE) {
      this.componentName = "AddMultipleSecuritiesDialogComponent-v002";
    }
  }

  ngOnInit(): void {
    if (this.eventData.type === 'securityModel') {
      this.dialogTitle = 'Add Multiple Securities to this Security Model';
    } else if (this.eventData.type === 'rebalance' || this.eventData.type === 'rebalanceTLH') {
      this.dialogTitle = 'Add Multiple Securities to this Rebalance';
    } else if (this.eventData.type === 'editSecurity' || this.eventData.type === 'adjustSecurity' || this.eventData.type === 'editPortfolioEquivalents') {
      this.dialogTitle = this.eventData.dialogTitle;
    }

    if(this.eventData.noDollarcash) {
      this.noDollarCash = true;
    } else {
      this.noDollarCash = false;
    }
    this.applyFilterOnLanding = this.as.getWindowsState();

    if (this.dataTransferService.SecurityModelId && this.dataTransferService.SecurityModelId.toString() !== '0') {
      this.securityModelId = this.dataTransferService.SecurityModelId.toString();
    }
    this.gridOptions = {
      rowModelType: 'serverSide',
      columnDefs: this.addMultipleSecuritiesGridService.getColumnDefs(this),
      context: {componentParent: this, parentId: 'add-multiple-securities-dialog-grid'}, // isDisabled: this.isDisabled
      rowSelection: 'multiple',
      overlayLoadingTemplate: "<div class='loading-spinner'></div>",
      onSortChanged: () => {
        this.setDatasource();
      }
    };

    this.frameworkComponents = this.addMultipleSecuritiesGridService.getFrameworkComponents();
    this.getSecuritiesCount();
    this.dataTransferService.SecurityModelId = '0';
  }

  processEvent(event: IEvent): void {
    switch(event.type) {
      case IrbAppEvents.GRID_FILTER_RESET:
        this.clearAllFilters();
        break;
    }
  }

  onGridReady(params: any) {
    this.params = params;
    if (this.applyFilterOnLanding) {
      if (!this.applyFilterOnLanding.isUpdatRequired) {
        this.params.api.setGridOption('serverSideDatasource', this.setDatasource());
      }
    }
    this.iss.getGlobalSettings().subscribe((globalSettings: any) => {
      if (globalSettings && globalSettings.securityCustAttrAbbr && this.params.api) {
        this.globalSettings = globalSettings;
        this.params.api.getColumnDef("customCategoryName").headerName = globalSettings.securityCustAttrAbbr;
        this.isTLHSetInGlobal = globalSettings?.isTlhLotLevel || globalSettings?.isTlhPositionLevel;
        this.params.api.refreshHeader();
      }
    });
    this.getSecurityTypeList();
    this.getSecuritySymbolList();
    this.getCustomCategoryList();
    this.getSecurityModelList();
    this.smac.getAssetClasses(this);
  }
  enableDisableBtns() {
    this.disableAddBtn = (this.isSelectedAll || this.selectedRowsMap?.size) ? false : true;
  }

  addSecurities() {
    let sec: any;
    let selectedSecurities: any = [];
    if (this.isSelectedAll){
      const request = {} as ISecurityelectAll;
      request.isSelectAll = this.isSelectedAll;
        request.deselectedIds = []; 
        this.securityMasterService.filterCriteria=this.filterCriteria;
        this.deselectedFromSelectAllRecords.forEach((node: any) => {
          request.deselectedIds.push(node.securityId);
        });
        request.selectedIds = [];
        this.securityMasterService.filterCriteria=this.filterCriteria;
        this.as.fireEvent(IrbAppEvents.SHOW_WAIT);

        if(this.eventData.type === "rebalance" || this.eventData.type === "rebalanceTLH") {
          this.securityMasterService.getSelectedSecurityMinDetails(request).subscribe((response: ISecurityType) => {
            this.completeAddSecurities(response);
          }, () => {
            this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
          });
        } else {
          this.securityMasterService.getSelectedSecurityIds(request).subscribe((response: ISecurityType) => {
            this.completeAddSecurities(response);
          });
        }
    } else {
      let selectedIds: any = [];
      if (this.params) {
        this.selectedRowsMap.forEach((node: any) => {
          if ( !this.isDisabled(node)) {
            selectedSecurities.push(node);
            selectedIds.push(node.securityId)
          }
        });
      }

      if (this.eventData.type !== "rebalanceTLH") {
        if (selectedSecurities.length !== 0) {
          const params = {
            type: this.eventData.type,
            selectedSecurities: selectedSecurities
          };
          this.as.fireEvent(IrbModelsEvents.SAVE_MASTER_MULTIPLE_SECURITY, params);
        }
      } else {
        const request: any = {
          isSelectAll: false,
          deselectedIds: [],
          selectedIds: selectedIds
        }
        this.securityMasterService.getSelectedSecurityMinDetails(request).subscribe((response: ISecurityType) => {
          this.completeAddSecurities(response);
        }, () => {
          this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
        });
      }
    }
    this.closeDialog();
  }

  completeAddSecurities(response: ISecurityType) {
    if (response.responseData && response.responseData.length > 0) {
      let selectedSecurities: any[] = [];
      response.responseData.forEach((data: any)=>{
        if(!this.isDisabled(data)) {
          selectedSecurities.push(data);
        }
      });
      const params = {
        type: this.eventData.type,
        selectedSecurities: selectedSecurities
      };
      this.securityMasterService.clearCriteria();
      this.as.fireEvent(IrbModelsEvents.SAVE_MASTER_MULTIPLE_SECURITY, params);
      this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
      this.closeDialog();
    }
  }

  clearAllFilters() {
    this.securityMasterService.filterCriteria = '';
    this.dataTransferService.SecurityModelId = '0';
    this.securityModelId = '0';
    if (this.params.api) {
      this.params.api.setFilterModel(null);
    }
    this.securityMasterService.clearCriteria();
  }

  // private isDisabled(node: any) {
  //   if (node.securityId === 1152438) {
  //     node.selected = true;
  //     return true
  //   };
  //
  //   return false;
  // }

  private getSecurityTypeList() {
    this.securityMasterService.getComboDropDownSecurityType().subscribe((res: ISecurityType) => {
      this.setFilterValues('securityType', res.responseData);
    });
  }

  private getSecuritySymbolList() {
    this.securityMasterService.getSecuritySymbolDropDownValues().subscribe((res: ISecuritySymbolList) => {
      this.securityList = res;
      this.securitySymbolList = res;
      const securitySymbolValues:any = [];
      for (const record of this.securitySymbolList.items) {
        if (record.securitySymbol) {
          securitySymbolValues.push(record.securitySymbol);
        }
      }
      this.setFilterValues('securitySymbol', securitySymbolValues);
      this.setFilterValues('washSaleSymbol', securitySymbolValues);
    });
  }

  private getCustomCategoryList() {
    this.securityMasterService.getCustomCategorDropDownValues().subscribe((res:ISecurityCustomCategories) => {
      const securitySymbolValues:any = [];
      this.customCategoriesList = res;

      for (const record of res.items) {
        if (record.custCatName) {
          securitySymbolValues.push(record.custCatName);
        }
      }
      
      this.setFilterValues('customCategoryName', securitySymbolValues.sort(this.compareCaseInsensitive));
    });
  }

  private getSecurityModelList() {
    this.securityMasterService.getSecurityModelDropDownValues().subscribe((res:ISecurityModelList) => {
      this.securityModelList = res;
      const noneModelItem = {
          securityModelId: -1,
          securityModelName: '(none)'
      };
      if (this.securityModelList?.items) {
        this.securityModelList.items.unshift(noneModelItem);
        const securitySymbolValues:any = [];
        for (const record of this.securityModelList.items) {
          if (record.securityModelName) {
            securitySymbolValues.push(record.securityModelName);
          }
        }
        this.securityModels = securitySymbolValues;
      }
      let filterModel:IFilterModel = this.as.getFieldInfo(this.applyFilterOnLanding, 'securityModelName');
      if(filterModel && filterModel.value && filterModel.isUpdatRequired){
        this.applyFilterOnLanding.isUpdatRequired = false;
        filterModel.isUpdatRequired = false;
        this.params.api.setColumnFilterModel('securityModels', {
          values: filterModel.value,
        });
        
        this.params.api.onFilterChanged()
        setTimeout (() => {
          this.params.api.setGridOption('serverSideDatasource', this.setDatasource());
        }, 500);

      }
    }, () => {
      this.params.api.setGridOption('serverSideDatasource', this.setDatasource());
    });
  }
  private compareCaseInsensitive(a: string, b: string) {
    if (a.toLowerCase() < b.toLowerCase()) return -1;
    if (a.toLowerCase() > b.toLowerCase()) return 1;
    return 0;
  }

  private resetGridData() {
    this.securityModelId = '0';
    this.dataTransferService.SecurityModelId = '0';
  }

  getSecModelFilterSelectedGetIds(params: any, list: ISecurityModelList, fieldName: string) {
    const selectedModelIds = [];
    if (params.request.filterModel && params.request.filterModel[fieldName]) {
      const selectedValues = params.request.filterModel[fieldName].values;
      if (selectedValues && selectedValues.length) {
        for (const record of selectedValues) {
          const result = list.items.filter(s1 => s1.securityModelName === record);
          selectedModelIds.push(result[0].securityModelId);
        }
      }
    }
    return selectedModelIds;
  }

  setDatasource() {
    return {
      getRows: ( params: any) => {
        let selectedModelIds;

        if (this.securityModelId?.toString() !== '0') {
          this.securityMasterService.filterCriteria = "&Filter=%26securityModel%3D" + this.securityModelId;
        } else {
          selectedModelIds = this.getSecModelFilterSelectedGetIds(params, this.securityModelList, 'securityModels');
        }

        if(this.noDollarCash) {
          this.securityMasterService.noDollarCash = this.noDollarCash;
        }
        

        this.params.api.showLoadingOverlay();
        this.securityMasterService.getInvSecurityMaster(params,this).subscribe((data: any) => {
          this.filterCriteria = this.securityMasterService.filterCriteria;
          this.securityMaster = <ISecurity[]> data.body;
          this.securityMasterService.clearCriteria();
          this.resetGridData();
          this.getCurrentCount(data.headers);

          if(this.currentSecurityMasterDisplayed === 0) {
            this.params.api.showNoRowsOverlay();
          } else {
            this.params.api.hideOverlay();
          }

          params.success({ rowData: this.securityMaster });
        }, () => {
            params.success({ rowData: [] });
            this.params.api.hideOverlay();
            this.params.api.showNoRowsOverlay();
        });
      }
    };
  }

  getCustomCategoryFilterIds(params: any, list: ISecurityCustomCategories, fieldName: string): Array<string> {
    const s: Array<string> = [];
  
    if (params.request.filterModel && params.request.filterModel[fieldName]) {
        const selectedValues = params.request.filterModel[fieldName].values;
        
        for (const r of selectedValues) {
            const result = list.items.filter(s1 => s1.custCatName === r);
  
            result.forEach((r: any) => {
                s.push(r.custCatId);
            });  
        }
    }
  
    return s;
  }

  getAssetClassIds(params: any) {
    const acLevel1 = params.request.filterModel?.acLevel1?.values || [];
    const acLevel2 = params.request.filterModel?.acLevel2?.values || [];
    const acLevel3 = params.request.filterModel?.acLevel3?.values || [];
    const acLevel4 = params.request.filterModel?.acLevel4?.values || [];
    return {
      "acLevel1": acLevel1,
      "acLevel2": acLevel2,
      "acLevel3": acLevel3,
      "acLevel4": acLevel4
    };
  }

  getMorningstarStyleIds(params: any) {
    return params.request.filterModel["styleBoxLabel"]?.values || [];
  }

  getWashSaleFilterIds(params: any, list: ISecuritySymbolList, fieldName: string) {
        const selectedIds: any = [];
    if (params.request.filterModel && params.request.filterModel[fieldName]) {
        const selectedValues = params.request.filterModel[fieldName].values;
        if (selectedValues && selectedValues.length) {
            for (const record of selectedValues) {
              if ( record === '(none)') {
                selectedIds.push(-10);
              } else {
                const result = list.items.filter(s1 => s1.securitySymbol === record);
                if (result.length !== 0) {
                    result.forEach((r:any) => {
                      selectedIds.push(r.securityId);
                    });
                }
              }
            }
        }
    }
    return selectedIds;
}
  private getCurrentCount(headers: HttpHeaders) {
    if (headers) {
      const contentRange = headers.get('Filter-Count');
      const lengthOfContentRange = contentRange ? contentRange.trim().length : 0;
      const indexOfSlash = contentRange ? contentRange.toString().indexOf('/') : 0;
      this.currentSecurityMasterDisplayed = contentRange ? parseInt(contentRange.toString().substring(indexOfSlash + 1, lengthOfContentRange)) : 0;
      this.footerContent = this.currentSecurityMasterDisplayed + ' of ' + this.securitiesCount + ' securities displayed';
      this.totalRecordsFromServer = this.currentSecurityMasterDisplayed;
    }
  }

  private setFilterValues(fieldName: string, setValuesList: string[]) {
    switch(fieldName) {
      case 'securitySymbol':
        this.securitySymbolList = setValuesList;
        break;
      case 'securityType':
        this.securityTypeList = setValuesList;
        break;
      case 'customCategoryName':
        this.customCategoryList = setValuesList;
        break;
      case 'washSaleSymbol':
           this.washSaleSymbolList = ['(none)', ...setValuesList];
           break;
        // case 'securityModels':
        //   this.securityModels = setValuesList;
        //   break;
    }
  }

  private getSecuritiesCount(): void {
    this.securityMasterService.getSecurityMasterCount().subscribe(securitiesCount => this.securitiesCount = securitiesCount);
  }



  closeDialog() {
    this.securityMasterService.filterCriteria = this.originalSecurityFilter;
    this.dialogRef.close();
  }

  ngOnDestroy() {
    this.destroyed$.complete();
  }

  isDisabled(data: any) {
    const field = this.eventData.field || "securityId";
    return this.eventData.data ? this.eventData.data.some((selectedSecurities: any) => {
      if (field === 'equivalentSecurityId') {
        return selectedSecurities.equivalentSecurityId === data.securityId;
      } else if (field === 'harvestSecId') {
        return selectedSecurities.harvestSecId === data.securityId;
      } else {
        return selectedSecurities.securityId === data.securityId;
      }
    }) : false;
  }

  addRemoveFilterToPanel() {
      let customToolPanelColumnDefs: any;
      customToolPanelColumnDefs = [
          {
              headerName: 'Additional Filters',
              children: []
          }
      ];
      return customToolPanelColumnDefs;
  }
}
